const initMap = () => {
    const myLatLng = {lat: 51.54854, lng: 0.63242};
    const image = './dist/images/map-marker.svg';

    const mapStyle = [
        {
            featureType: 'poi',
            elementType: 'labels.text',
            stylers: [{visibility: 'off'}],
        },
    ];

    // const isSmallScreen = window.innerWidth <= 768;
    // const zoomLevel = isSmallScreen ? 15 : 16;

    const map = new google.maps.Map(document.getElementById('map'), {
        center: myLatLng,
        zoom: 16,
        styles: mapStyle,
    });

    const marker = new google.maps.Marker({
        position: myLatLng,
        map,
        icon: image,
        title: 'Storm Studio',
    });

    google.maps.event.addListener(marker, 'click', () => {
        const url = `https://www.google.com/maps/dir/?api=1&destination=${myLatLng.lat},${myLatLng.lng}`;

        window.open(url, '_blank');
    });
};

window.initMap = initMap;
